/**
 * @desc 文件上传
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<defs.FileUploadResponse>>> {
  return fetch({
    url: config.API_HOST + '/upload/uploadFile',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
